<template>
  <v-menu class="senate-select-menu" offset-y>
    <v-btn class="select-menu-button" block slot="activator" color="primary" large outline dark>
      <span style="font-size: 18px; font-weight: 500; letter-spacing: 0.1em;">Go to {{ chamber | capitalize }} Page</span>
      <v-icon class="ml-2">arrow_drop_down</v-icon>
    </v-btn>
    <v-list class="seats-list" v-if="chamber === 'senate'">
      <v-list-tile v-for="(item, index) in senateSeats" :key="index" @click="$router.push({ name: 'senate', params: { raceId: item.raceId }})">
        <v-list-tile-title v-if="item.specialElection">{{ item.state }} (Special)</v-list-tile-title>
        <v-list-tile-title v-else>{{ item.state }}</v-list-tile-title>
      </v-list-tile>
    </v-list>
    <v-list class="seats-list" v-if="chamber === 'house'">
      <v-list-tile v-for="(item, index) in houseSeats" :key="index" @click="$router.push({ name: 'house', params: { raceId: item.raceId }})">
        <v-list-tile-title>{{ item.state }} {{ item.cd }}</v-list-tile-title>
      </v-list-tile>
    </v-list>
  </v-menu>
</template>

<script>
import { mapGetters } from 'vuex'

const props = {
  chamber: {
    type: String,
    required: true
  },
  filterState: {
    type: String,
    required: false
  }
}

const computed = {
  ...mapGetters({
    elections: 'elections/list'
  }),
  senateSeats () {
    const elections = this.elections.filter(item => item.cd === null)
    return elections.sort((a, b) => a.state.localeCompare(b.state))
  },
  houseSeats () {
    let elections = this.elections.filter(item => item.cd !== null && item.specialElection !== true)

    if (this.filterState && this.filterState !== 'United States') {
      elections = elections.filter((item) => { return item.state === this.filterState })
    }

    return elections.sort((a, b) => {
      const nameA = a.state + a.cd
      const nameB = b.state + b.cd
      return nameA.localeCompare(nameB)
    })
  }
}

export default {
  props,
  computed
}
</script>

<style>
.senate-select-menu {
  z-index: 450;
  width: 100%;
}

.seats-list {
  height: 200px;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
}
</style>



// WEBPACK FOOTER //
// src/components/MobileSeatList.vue